import type { ReactElement, ReactNode } from 'react';
import PropTypes from 'prop-types';

// @floating-ui types
import type { ContextData } from '@floating-ui/react';

// generic types
import type { colors, dismissType, animation, offsetType } from '../generic';
import {
  propTypesColors,
  propTypesOffsetType,
  propTypesDismissType,
  propTypesAnimation,
} from '../generic';
import type React from 'react';

/**
 * This file contains the types and prop-types for Select, SelectOption and SelectContext components.
 */

// typescript types
export type variant = 'standard' | 'outlined' | 'static';
export type size = 'md' | 'lg';
export type color = colors;
export type label = string;
export type error = boolean;
export type success = boolean;
export type arrow = ReactNode;
export type value = string;
export type onChange = (value?: string) => void;
export type selected = (element?: ReactElement, index?: number) => React.ReactNode;
export type offset = offsetType;
export type dismiss = dismissType;
export type animate = animation;
export type autoHeight = boolean;
export type lockScroll = boolean;
export type labelProps = {
  [key: string]: any;
};
export type menuProps = {
  [key: string]: any;
};
type index = number;
export type disabled = boolean;
export type className = string;
type name = string;
type children = ReactNode;
export type containerProps = React.ComponentProps<'div'>;
type contextValue = {
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  activeIndex?: number | null;
  setActiveIndex: (index: number | null) => void;
  listRef: React.MutableRefObject<Array<HTMLLIElement | null>>;
  setOpen: (open: boolean) => void;
  onChange: (value: string) => void;
  getItemProps: (userProps?: React.HTMLProps<HTMLElement>) => any;
  dataRef: ContextData;
};

// javascript prop-types
export const propTypesVariant: any = ['standard', 'outlined', 'static'];
export const propTypesSize: any = ['md', 'lg'];
export const propTypesColor: any = propTypesColors;
const propTypesLabel: any = PropTypes.string;
const propTypesError: any = PropTypes.bool;
const propTypesSuccess: any = PropTypes.bool;
const propTypesArrow: any = PropTypes.node;
const propTypesValue: any = PropTypes.string;
const propTypesOnChange: any = PropTypes.func;
const propTypesSelected: any = PropTypes.func;
const propTypesOffset: any = propTypesOffsetType;
const propTypesDismiss: any = propTypesDismissType;
const propTypesAnimate: any = propTypesAnimation;
const propTypesAutoHeight: any = PropTypes.bool;
const propTypesLockScroll: any = PropTypes.bool;
const propTypesLabelProps: any = PropTypes.instanceOf(Object);
const propTypesMenuProps: any = PropTypes.instanceOf(Object);
const propTypesIndex: any = PropTypes.number;
const propTypesDisabled: any = PropTypes.bool;
const propTypesClassName: any = PropTypes.string;
const propTypesName: any = PropTypes.string;
const propTypesChildren: any = PropTypes.node.isRequired;
const propTypesContainerProps: any = PropTypes.instanceOf(Object);
const propTypesContextValue: any = PropTypes.shape({
  selectedIndex: PropTypes.number.isRequired,
  setSelectedIndex: PropTypes.func.isRequired,
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  setActiveIndex: PropTypes.func.isRequired,
  listRef: PropTypes.instanceOf(Object).isRequired,
  setOpen: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  getItemProps: PropTypes.func.isRequired,
  dataRef: PropTypes.instanceOf(Object).isRequired,
}).isRequired;
